<template>
  <aside class="sidenav" :class="{active: activeSideNav}">
    <div class="sidenav-header">
      <img alt="BCR logo" src="@/assets/images/front_logo_inverted.svg">
    </div>

    <div class="sidenav-close" @click="toggleSideNav"></div>    

    <div class="sidenav-list" v-if="$route.name !== 'change-password'">
      <ul>
        <li><span><router-link to="/admin/offers" :key='$route.params.id || $route.params'><vs-icon icon="shopping_cart"></vs-icon> Ofertas</router-link></span></li>
        <li><span><router-link to="/admin/operations" :key='$route.params.id || $route.params'><vs-icon icon="compare_arrows"></vs-icon> Operaciones</router-link></span></li>
        <li><span><router-link to="/admin/organizations" :key='$route.params.id || $route.params'><vs-icon icon="group"></vs-icon> Empresas</router-link></span></li>
        <li><span><router-link to="/admin/dashboard" :key='$route.params.id || $route.params'><vs-icon icon="equalizer"></vs-icon> Estadísticas</router-link></span></li>
        <li><span><router-link to="/admin/audit-logs" :key='$route.params.id || $route.params'><vs-icon icon="computer"></vs-icon> Auditoría de usuarios</router-link></span></li>
        <li><span><router-link to="/admin/settings" :key='$route.params.id || $route.params'><vs-icon icon="settings"></vs-icon> Configuraciones</router-link></span></li>
        <li><span><router-link to="/admin/logistic-orders" :key='$route.params.id || $route.params'><vs-icon icon="local_shipping"></vs-icon> Logistica</router-link></span></li>
      </ul>
    </div>
  </aside>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      activeSideNav: false
    }
  },
  computed: {
    ...mapState({
      currentUser: state => state.User.currentUser
    })
  },
  methods: {
    toggleSideNav () {
      this.activeSideNav = !this.activeSideNav
    }
  },
  mounted() {
    this.$root.$on('toggleMenu', data => {
      this.activeSideNav = !this.activeSideNav
    });
  },
  watch: {
    '$route' () {
      this.activeSideNav = !this.activeSideNav
    }
  }
}
</script>
